import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const CirclePlus = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.99957 17.2218C13.9883 17.2218 17.2218 13.9883 17.2218 9.99957C17.2218 6.01084 13.9883 2.77734 9.99957 2.77734C6.01084 2.77734 2.77734 6.01084 2.77734 9.99957C2.77734 13.9883 6.01084 17.2218 9.99957 17.2218Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M9.40606 13.5V6.5H10.5939V13.5H9.40606ZM6.5 10.5939V9.40606H13.5V10.5939H6.5Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default CirclePlus;